const colors = {
  base: '#FAFAFA',
  primary: {
    paleOrange: '#FFEDCD',
    softOrange: '#FFD79B',
    lightOrange: '#FFBB69',
    brightOrange: '#FF9F44',
    orange: '#FF7206',
    deepTangerine: '#DB5504',
    intenseOrange: '#B73D03',
    darkOrange: '#932801',
    deepOrange: '#7A1A01',
  },
  secondary: {
    white: '#FDFDFD',
    softBlue: '#F7F9FC',
    lightBlue: '#EDF1F7',
    brightBlue: '#E4E9F2',
    blue: '#C5CEE0',
    deepSky: '#8F9BB3',
    intenseNavy: '#2E3A59',
    darkNavy: '#222B45',
    deepNavy: '#192038',
  },

  success: {
    paleLime: '#E6FCD6',
    softLime: '#C8FAAF',
    lightLime: '#9FF285',
    brightLime: '#79E664',
    green: '#42D635',
    deepGreen: '#26B826',
    intenseGreen: '#1A9A25',
    darkGreen: '#107C22',
    deepForest: '#0A6621',
  },
  warning: {
    paleGold: '#FEF6CC',
    softGold: '#FEEB9A',
    lightGold: '#FEDC68',
    brightGold: '#FDCD43',
    gold: '#FCB605',
    deepTangerine: '#D89603',
    intenseGold: '#B57802',
    darkGold: '#925C01',
    deepAmber: '#784800',
  },

  error: {
    lightRed: '#FFECDB',
    softRed: '#FFD5B8',
    paleRed: '#FFB895',
    brightRed: '#FF9C7A',
    red: '#FF6F4F',
    deepRed: '#DB4A39',
    intenseRed: '#B72C27',
    darkRed: '#93191E',
    richRed: '#7A0F1C',
  },

  neutral: {
    superLightGray: '#F9F9F9',
    ultraLightGray: '#F3F3F3',
    veryLightGray: '#DDDDDD',
    lightGray: '#CCCCCC',
    paleGray: '#E4E9F2',
    gray: '#8F9BB3',
    mediumGray: '#A5A5A5',
    charcoal: '#868484',
    slateGray: '#3D3D3D',
    black: '#3F3F3F',
    darkGray: '#2D2D2D',
  },
};

export default colors;
